
import { initializeApp } from "firebase/app";
import firebaseConfig from "./Firebase.config";

const inililizationAuth=()=>{
     initializeApp(firebaseConfig);
}

export default inililizationAuth